import {createSlice} from "@reduxjs/toolkit";

const initialCustomersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  dataForEdit: undefined,
  lastError: null,
  error: null,
  settings: null,
  plan: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const profileSlice = createSlice({
  name: "profile",
  initialState: initialCustomersState,
  reducers: 
    // persistReducer(
    // { storage: AsyncStorage, key: config.key_home, whitelist: ["request"] },
    {
    reset: (state) => {
      state = initialCustomersState;
    },  
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    clearError: (state, action) => {
      state.error = null
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    dataFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.settings = action.payload;
      state.error = null;
    },
    // findCustomers
    datasFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    stopLoading: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
    },
    dangerFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.danger = action.payload;
    },
    // findCustomers
    planFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.plan = action.payload;
    },
    cyptoFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.cypto = action.payload;
    },
    bankFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.banks = action.payload;
    },
    payeeFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.payee = action.payload;
    },
    cardsFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.cards = action.payload;
    },
    configFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.config = action.payload;
    },
    transFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.trans = action.payload;
    },
    // createCustomer
    dataCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
    },
    // updateCustomer
    dataUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.data.id) {
          return action.payload.data;
        }
        return entity;
      });
    },
    // deleteCustomer
    dataDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteCustomers
    datasDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // datasUpdateState
    datasStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
  // })
});
